export const COURSE_AVAILABILITY_STATUS_LIST = [
  'frei',
  'ausgebucht',
  'fast ausgebucht',
] as const;

export const COURSE_STATUS_LABEL_MAPPER: Record<
  (typeof COURSE_AVAILABILITY_STATUS_LIST)[number],
  string
> = {
  frei: 'Freie Plätze',
  ausgebucht: 'Kurs ausgebucht',
  'fast ausgebucht': 'Wenige Plätze verfügbar',
} as const;

export const COURSE_YEAR_QUARTER_SEPARATOR = '-';
